import { parseISO } from 'libs/dates'

export function parseDate(value: string | null): Date | undefined {
	if (!value) return undefined
	const d = parseISO(value)
	return isNaN(d.getTime()) ? undefined : d
}
